import { computed, type Ref, toValue } from 'vue';
import { ValueObject } from '@keyvue/one-api-client';

export default function useScalarSelectInput(
    scalarValue: Ref<any>,
    items: Ref<any[]> | any[],
    valueKeyName: string = 'value',
) {
    const getValue = (item: any) => {
        let value = toValue(item)?.[valueKeyName];
        if (value && value instanceof ValueObject) {
            value = value.value;
        }

        return value;
    };

    const value = computed({
        get() {
            const selectedValue = toValue(scalarValue);
            if (!selectedValue) {
                return null;
            }

            return toValue(items).find((i) => getValue(i) === selectedValue);
        },
        set(selectedItem) {
            // eslint-disable-next-line no-param-reassign
            scalarValue.value = getValue(selectedItem);
        },
    });

    return value;
}
